import { Registration } from "../models/Registration";
import { RegistrationListReportTemplateData } from "./RegistrationListReportTemplateData";
import { RegistrationListReportImportTemplate } from "./RegistrationListReportImportTemplate";
import { cloneDeep } from "lodash";

export const getRegistrationListReportTemplate = (
        reportData: Registration[],
    ) => {
    return RegistrationListReportImportTemplate(
        prepareData(reportData)
    );
};

const prepareData = (reportData: Registration[]) => {
    const templateData: RegistrationListReportTemplateData = {//@ts-ignore
        reportData: (cloneDeep(reportData)).sort((a: Registration, b: Registration) => a.createdAt < b.createdAt ? 1 : -1)
    };

    return templateData;
};